import React from "react";
import RemainingSessionsModule from "./remainingSessionsModule";
import RemainingSessionsSagas from "./redux/remainingSessionsSagas";
import RemainingSessionsReducer from "./redux/remainingSessionsReducer";
import PageWithConfigurator from "../../shared/pageWithConfigurator/pageWithConfigurator";

const pageConfig = {
  pageName: "Sessions",
  moduleList: [
    {
      Component: RemainingSessionsModule,
      moduleName: "sessions",
      saga: RemainingSessionsSagas(),
      reducer: RemainingSessionsReducer
    }
  ],
  hideConfigurator: true
};

const RemainingSessionsPage = ({ notifications }) => {
  return <PageWithConfigurator pageConfig={pageConfig} notifications={notifications} />;
};

export default RemainingSessionsPage;
